<script>
'use strict';

const StoryList = require('./StoryList.vue');
const ProductList = require('./ProductList.vue');
const SkeletonStoryCard = require('./SkeletonStoryCard.vue');
const SkeletonProductCard = require('./SkeletonProductCard.vue');

const SKELETON_STORY_COUNT = 3;
const SKELETON_PRODUCT_COUNT = 8;

module.exports = {
  name: 'TopResultsSection',
  components: {
    StoryList,
    ProductList,
    SkeletonStoryCard,
    SkeletonProductCard,
  },
  data() {
    return {
      skeletonStoryCount: SKELETON_STORY_COUNT,
      skeletonProductCount: SKELETON_PRODUCT_COUNT,
    };
  },
  computed: {
    stories() {
      return this.$store.state.storyResults || [];
    },
    loading() {
      return this.$store.state.loading;
    },
    hasStories() {
      return this.stories.length > 0;
    },
  },
};
</script>

<template>
  <div class="top-results-section">
    <!-- Mobile/tablet only skeleton — hidden on desktop via CSS -->
    <div class="top-results-loading" v-if="loading">
      <div class="story-list">
        <SkeletonStoryCard v-for="n in skeletonStoryCount" :key="`s-${n}`" />
      </div>
      <div class="top-results-divider" />
      <div class="product-list">
        <SkeletonProductCard v-for="n in skeletonProductCount" :key="`p-${n}`" />
      </div>
    </div>
    <template v-else>
      <StoryList :stories="stories" context="top-results" :limit="3" v-show="hasStories" />
      <div
        class="top-results-divider"
        :class="[hasStories ? '' : 'no-stories']" />
      <ProductList limit="8" actionLink="see all" />
    </template>
  </div>
</template>

<style scoped lang="postcss"></style>
